/**
 * @description 全局Model circleModal 挂载到 redux 上
 */
import createModel, { Tction, tPut } from '@tkit/model';

import {
  APIS,
  ParamsgroupsGroupIdUsingGet,
  ParamsgroupsGroupIdLastUsingGet,
  ParamsgroupsGroupIdUsersUsingGet,
  ParamsgroupsGroupIdJoinUsingPost,
  ParamsgroupsGroupIdKickUsingPost,
  ParamsquestionQuestionIdCollectUsingPost,
  ParamsgroupsGroupIdAuditedlistUsingGet,
  ParamsgroupsGroupIdAuditedOperaUsingPut,
  ParamsBodyuserFollowUsingPost,
  PageableResultGroupUserInfo,
  SimpleUserInfo,
  PageableResult,
  GroupVO,
  ParamsgroupsStickArticleOrQuestionIdUsingPut,
  ParamsgroupsGroupIdVotelistUsingGet,
  ParamsvoteFollowVoteQuestionIdUsingPost
} from '@src/services';
import { TkitUtils as Utils } from '@tkit/types';
import * as models from '@services/model/models';
import { message } from 'antd';

import {
  HOME_ANSWER_AGREE_ACTION_TYPE,
  HOME_ANSWER_DISAGREE_ACTION_TYPE
} from '@src/utils/constant/home';

import { NETWORK_ERROR_TIP, PAGE_SIZE } from '@src/utils/constant/common';

const agreeDisagreeNextMap = {
  [HOME_ANSWER_AGREE_ACTION_TYPE]: {
    0: { tip: '已赞同', agreeStatus: 1 },
    1: { tip: '已取消赞同', agreeStatus: 0 },
    2: { tip: '已赞同', agreeStatus: 1 }
  },
  [HOME_ANSWER_DISAGREE_ACTION_TYPE]: {
    0: { tip: '已反对', agreeStatus: 2 },
    1: { tip: '已反对', agreeStatus: 2 },
    2: { tip: '已取消反对', agreeStatus: 0 }
  }
};

export interface GroupUsersListModal<T> {
  list?: Array<T>;
  pageNum?: number;
  pageSize?: number;
  total?: number;
}

export interface State {
  circleModal: {};
  groupInfoModal: GroupVO;
  askListModel: models.PageableResultSingleArticleInfo;
  answerListModel: models.PageableResultSingleArticleInfo;
  newArticleListModel: models.PageableResultSingleArticleInfo;

  /**  圈子成员列表 */
  groupUsersListModel: PageableResultGroupUserInfo;
  /** 圈子请求列表 */
  groupUsersRequireModel: GroupUsersListModal<SimpleUserInfo>;
  loading: boolean;
  /** 投票 */
  voteListModel: models.PageableResultVoteQuestionSimplePO;
}

export const circleModalState: State = {
  circleModal: {},
  groupInfoModal: {},
  newArticleListModel: {},
  askListModel: {},
  answerListModel: {},
  groupUsersListModel: {},
  groupUsersRequireModel: {},
  loading: false,
  voteListModel: {}
};

const model = createModel({
  state: circleModalState,
  namespace: 'circleModal',
  reducers: {
    /** 获取投票问题列表 */
    setVoteList: (
      state,
      action: Tction<{ voteListModel: models.PageableResultVoteQuestionSimplePO }>
    ) => {
      const { voteListModel } = action.payload;
      return {
        ...state,
        voteListModel
      };
    },
    // 圈子详情
    setGroupInfo: (state, action: Tction<{ groupInfoModal: any }>) => {
      const { groupInfoModal } = action.payload;
      return {
        ...state,
        groupInfoModal
      };
    },

    // 获取最新文章
    setNewArticleList: (state, action: Tction<any>) => {
      return {
        ...state,
        newArticleListModel: action.payload
      };
    },

    // 获取提问
    setAskList: (state, action: Tction<{ askListModel: PageableResult }>) => {
      const { askListModel } = action.payload;
      return {
        ...state,
        askListModel
      };
    },
    // 获取回答
    setAnswerList: (state, action: Tction<any>) => {
      return {
        ...state,
        answerListModel: action.payload
      };
    },

    // 更新loading状态
    updateLoading: (state, action: Tction<{ loading: boolean }>) => {
      const { loading } = action.payload;
      return {
        ...state,
        loading
      };
    },
    /** 设置圈子成员列表 */
    setGroupUsersList: (
      state,
      action: Tction<{ groupUsersListModel: PageableResultGroupUserInfo }>
    ) => {
      const { groupUsersListModel } = action.payload;
      return {
        ...state,
        groupUsersListModel
      };
    },
    /** 设置申请加入圈子成员列表 */
    setGroupUsersRequestList: (
      state,
      action: Tction<{
        groupUsersRequireModel: GroupUsersListModal<SimpleUserInfo>;
      }>
    ) => {
      const { groupUsersRequireModel } = action.payload;
      return {
        ...state,
        groupUsersRequireModel
      };
    },

    // 重置页面数据
    setReset: (state: any) => {
      return {
        ...state,
        groupInfoModel: {},
        newArticleListModel: {},
        askListModel: {},
        answerListModel: {},
        groupUsersListModel: {},
        groupUsersRequireModel: {},
        topicListModel: {}
      };
    },
    // 更新问题状态
    updateAskStatus: (state, action: Tction<{ questionIdVal: number; key: string; val: any }>) => {
      const { questionIdVal, key, val } = action.payload;
      const { askListModel } = state;
      const { list } = askListModel;
      return {
        ...state,
        askListModel: {
          ...askListModel,
          list:
            (list &&
              list.map((item: models.QuestionSimpleInfo) => {
                if (item.questionId === questionIdVal) {
                  return {
                    ...item,
                    [key]: val
                  };
                }
                return {
                  ...item
                };
              })) ||
            []
        }
      };
    },
    updateHomeAnswerAgreeDisagree: (
      state,
      action: Tction<{
        index: number;
        agreeStatus: number;
        agreeCount: number;
        disagreeCount: number;
      }>
    ) => {
      const { index, agreeStatus, agreeCount, disagreeCount } = action.payload;

      return {
        ...state,
        answerListModel: {
          ...state.answerListModel,
          list:
            state.answerListModel.list &&
            state.answerListModel.list.map((item: any, i: number) => {
              if (index === i) {
                return {
                  ...item,
                  agreeStatus: agreeStatus,
                  agreeCount: agreeCount,
                  disagreeCount: disagreeCount
                };
              }
              return item;
            })
        }
      };
    },
    /** 更新圈子详情,成员数量 */
    updateGroupInfoMember: (state, action: Tction<{ add: boolean }>) => {
      const { add } = action.payload;
      const { groupInfoModal } = state;

      return {
        ...state,
        groupInfoModal: {
          ...groupInfoModal,
          member: add ? (groupInfoModal.member || 0) + 1 : (groupInfoModal.member || 0) - 1
        }
      };
    },
    /** 更新圈子详情 ，免审批状态*/
    updateGroupInfoChecked: (state, action: Tction<{ checked: boolean }>) => {
      const { checked } = action.payload;
      const { groupInfoModal } = state;

      return {
        ...state,
        groupInfoModal: {
          ...groupInfoModal,
          isChecked: checked
        }
      };
    },
    /** 用户和圈子之间关系切换 */
    updateGroupInfo: (
      state,
      action: Tction<{
        join: boolean;
      }>
    ) => {
      const { join } = action.payload;
      const { groupInfoModal } = state;

      return {
        ...state,
        groupInfoModal: {
          ...groupInfoModal,
          joined: join,
          relation: join ? 1 : 0,
          member: join ? (groupInfoModal.member || 0) + 1 : (groupInfoModal.member || 0) - 1
        }
      };
    },
    /** 同意用户加入状态 */
    updateAuditedOfUser: (
      state,
      action: Tction<{
        username: string;
        agree: boolean;
      }>
    ) => {
      const { username, agree } = action.payload;

      return {
        ...state,
        groupUsersListModel: {
          ...state.groupUsersListModel,
          list:
            state.groupUsersListModel.list &&
            state.groupUsersListModel.list.map((item: any) => {
              if (item.username === username) {
                return {
                  ...item,
                  relation: agree ? 1 : 3
                };
              }
              return item;
            })
        }
      };
    },
    /** 用户关注切换 */
    updateUserFollow: (
      state,
      action: Tction<{
        ifFollow: boolean;
        targetUser: string;
      }>
    ) => {
      const { ifFollow, targetUser } = action.payload;

      return {
        ...state,
        groupUsersListModel: {
          ...state.groupUsersListModel,
          list:
            state.groupUsersListModel.list &&
            state.groupUsersListModel.list.map((item: any) => {
              if (item.username === targetUser) {
                return {
                  ...item,
                  followed: ifFollow
                };
              }
              return item;
            })
        }
      };
    },
    /**
     * @description 更新用户投票关注
     */
    updateVoteFollow: (state, action: Tction<{ type: boolean; voteId: number }>) => {
      const { type, voteId } = action.payload;
      const { list } = state.voteListModel;
      return {
        ...state,
        voteListModel: {
          ...state.voteListModel,
          list:
            list &&
            list.map((item: models.VoteQuestionSimplePO) => {
              if (item.voteQuestionId === voteId) {
                return {
                  ...item,
                  concerned: type
                };
              }
              return item;
            })
        }
      };
    }
  },
  effects: {
    // 加入/退出圈子
    *doUserJoinOrLeaveGroup(
      { tCall },
      action: Tction<{
        params: ParamsgroupsGroupIdJoinUsingPost;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.GroupApi.groupsGroupIdJoinUsingPost> = yield tCall(
        APIS.GroupApi.groupsGroupIdJoinUsingPost,
        params
      );
      if (res.code === 0) {
        const { join } = params;
        yield tPut(model.actions.updateGroupInfo, { join });
        callBack && callBack();
      }
    },

    // 获取圈子详情
    *getGroupById(
      { tPut, tCall },
      action: Tction<{
        params: ParamsgroupsGroupIdUsingGet;
        callBack: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.GroupApi.groupsGroupIdUsingGet> = yield tCall(
        APIS.GroupApi.groupsGroupIdUsingGet,
        action.payload.params
      );
      if (res.code === 0) {
        yield tPut(model.actions.setGroupInfo, { groupInfoModal: res.result || {} });
        action.payload.callBack(res);
      }
    },
    // 获取最新文章
    *getNewArticleList(
      { tPut, tCall },
      action: Tction<{
        params: ParamsgroupsGroupIdLastUsingGet;
        needLoading?: boolean;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { callBack, needLoading = true } = action.payload;

      if (needLoading) {
        yield tPut(model.actions.updateLoading, {
          loading: true
        });
      }
      const res = yield tCall(APIS.GroupApi.groupsGroupIdLastUsingGet, action.payload.params);
      if (needLoading) {
        yield tPut(model.actions.updateLoading, {
          loading: false
        });
      }
      const { code, result } = res;

      if (code === 0 && result) {
        yield tPut(model.actions.setNewArticleList, result);
        callBack && callBack();
      }
    },
    // 获取问题
    *getAskList(
      { tPut, tCall },
      action: Tction<{
        params: ParamsgroupsGroupIdLastUsingGet;
        needLoading?: boolean;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { callBack, needLoading = true } = action.payload;
      if (needLoading) {
        yield tPut(model.actions.updateLoading, {
          loading: true
        });
      }
      const res: Utils.GetROA<typeof APIS.GroupApi.groupsGroupIdLastUsingGet> = yield tCall(
        APIS.GroupApi.groupsGroupIdLastUsingGet,
        action.payload.params
      );
      if (needLoading) {
        yield tPut(model.actions.updateLoading, {
          loading: false
        });
      }
      const { code, result } = res;

      if (code === 0 && result) {
        yield tPut(model.actions.setAskList, { askListModel: result || {} });
        callBack && callBack();
      }
    },
    // 获取回答
    *getAnswerList(
      { tPut, tCall },
      action: Tction<{
        params: ParamsgroupsGroupIdLastUsingGet;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.updateLoading, {
        loading: true
      });
      const res = yield tCall(APIS.GroupApi.groupsGroupIdLastUsingGet, action.payload.params);
      yield tPut(model.actions.updateLoading, {
        loading: false
      });
      const { code, result } = res;
      const { callBack } = action.payload;
      if (code === 0 && result) {
        yield tPut(model.actions.setAnswerList, result);
        callBack && callBack();
      }
    },
    /**
     * @description 获取投票
     */
    *getVoteList(
      { tPut, tCall },
      action: Tction<{
        params: ParamsgroupsGroupIdVotelistUsingGet;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.updateLoading, {
        loading: true
      });
      const res = yield tCall(APIS.GroupApi.groupsGroupIdVotelistUsingGet, action.payload.params);
      yield tPut(model.actions.updateLoading, {
        loading: false
      });
      const { code, result } = res;
      const { callBack } = action.payload;
      if (code === 0 && result) {
        yield tPut(model.actions.setVoteList, { voteListModel: result || {} });
        callBack && callBack();
      }
    },
    // 获取圈子成员
    *getGroupUsersList(
      { tPut, tCall },
      action: Tction<{
        params: ParamsgroupsGroupIdUsersUsingGet;
        needLoading?: boolean;
        callBack?: (num: number) => void;
      }>
    ): Iterator<{}, any, any> {
      const { callBack, needLoading = true } = action.payload;
      if (needLoading) {
        yield tPut(model.actions.updateLoading, {
          loading: true
        });
      }
      const res: Utils.GetROA<typeof APIS.GroupApi.groupsGroupIdUsersUsingGet> = yield tCall(
        APIS.GroupApi.groupsGroupIdUsersUsingGet,
        action.payload.params
      );
      if (needLoading) {
        yield tPut(model.actions.updateLoading, {
          loading: false
        });
      }
      const { code, result } = res;
      if (code === 0 && result) {
        yield tPut(model.actions.setGroupUsersList, { groupUsersListModel: result });
        callBack && callBack(result.total || 0);
      } else {
        message.error(res.message);
      }
    },

    // 重置页面数据
    *reset({ tPut }): Iterator<{}, any, any> {
      yield tPut(model.actions.setReset);
    },
    // 问答关注
    *doFollowHomeQuestion(
      { tPut, tCall },
      action: Tction<{
        params: ParamsquestionQuestionIdCollectUsingPost;
        callBack?: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const {
        params,
        callBack,
        params: { questionId, type }
      } = action.payload;
      const parmsObj = { questionIdVal: questionId, key: 'isFollowing', val: true };
      yield tPut(model.actions.updateAskStatus, parmsObj);
      const res = yield tCall(APIS.QuestionApi.questionQuestionIdCollectUsingPost, params);
      const { code } = res;
      if (code === 0) {
        yield tPut(model.actions.updateAskStatus, {
          questionIdVal: questionId,
          key: 'hasFollow',
          val: type
        });
      }
      parmsObj.val = false;
      yield tPut(model.actions.updateAskStatus, parmsObj);
      callBack && callBack(res);
    },

    /**
     * @description 移出圈子
     * @param param0 groupId 圈子id
     * @param action username  用户邮箱前缀
     */
    *outOfCircleByUserName(
      { tPut, tCall },
      action: Tction<{
        params: ParamsgroupsGroupIdKickUsingPost;
        pageNum: number;
        pageSize: number;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.GroupApi.groupsGroupIdKickUsingPost> = yield tCall(
        APIS.GroupApi.groupsGroupIdKickUsingPost,
        action.payload.params
      );
      const { groupId } = action.payload.params;
      const { pageNum, pageSize, callBack } = action.payload;
      if (res.code === 0) {
        yield tPut(model.actions.getGroupUsersList, {
          params: { groupId, pageNum, pageSize },
          needLoading: false
        });
        yield tPut(model.actions.updateGroupInfoMember, { add: false });
        callBack && callBack();
        message.success('成功踢出圈子');
      } else {
        message.error(res.message);
      }
    },
    /**
     * @description 获取加入圈子的申请列表
     * @param param 圈子id
     */
    *getApplicationList(
      { tPut, tCall },
      action: Tction<{
        params: ParamsgroupsGroupIdAuditedlistUsingGet;
        needLoading?: boolean;
      }>
    ): Iterator<{}, any, any> {
      const { needLoading = true } = action.payload;
      if (needLoading) {
        yield tPut(model.actions.updateLoading, {
          loading: true
        });
      }
      const res: Utils.GetROA<typeof APIS.GroupApi.groupsGroupIdAuditedlistUsingGet> = yield tCall(
        APIS.GroupApi.groupsGroupIdAuditedlistUsingGet,
        action.payload.params
      );
      if (needLoading) {
        yield tPut(model.actions.updateLoading, {
          loading: false
        });
      }
      if (res.code === 0) {
        yield tPut(model.actions.setGroupUsersRequestList, {
          groupUsersRequireModel: res.result || {}
        });
      } else {
        message.error(res.message);
      }
    },

    /**
     * @description 同意或拒绝加入申请
     * @param param0
     */
    *auditedOperaGroup(
      { tPut, tCall },
      action: Tction<{
        params: ParamsgroupsGroupIdAuditedOperaUsingPut;
      }>
    ): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.GroupApi.groupsGroupIdAuditedOperaUsingPut> = yield tCall(
        APIS.GroupApi.groupsGroupIdAuditedOperaUsingPut,
        action.payload.params
      );
      if (res.code === 0) {
        const { agree, groupId, username } = action.payload.params;
        yield tPut(model.actions.updateAuditedOfUser, {
          username,
          agree
        });
        if (agree) {
          yield tPut(model.actions.updateGroupInfoMember, { add: true });
        }
        yield tPut(model.actions.getApplicationList, {
          params: { groupId, pageNum: 1, pageSize: 10 },
          needLoading: false
        });
        message.success(agree ? '已同意加入圈子' : '已拒绝加入圈子');
      } else {
        message.error(res.message);
      }
    },
    /**
     * @description 用户关注切换
     */
    *toggleFollowUser(
      { tPut, tCall },
      action: Tction<{
        params: ParamsBodyuserFollowUsingPost;
      }>
    ): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.UserApi.userFollowUsingPost> = yield tCall(
        APIS.UserApi.userFollowUsingPost,
        action.payload.params
      );

      if (res.code === 0) {
        const { ifFollow, targetUser } = action.payload.params;
        yield tPut(model.actions.updateUserFollow, {
          ifFollow: ifFollow || false,
          targetUser: targetUser || ''
        });
        message.success(ifFollow ? '关注成功' : '已取消关注');
      } else {
        message.error(res.message);
      }
    },
    doAgreeDisagreeHomeAnswer: [
      function*(
        { tCall, tPut },
        action: Tction<{
          answerId: number;
          index: number;
          clickedType: string;
          currentType: number;
        }>
      ): Iterator<{}, any, any> {
        const { answerId, index, clickedType, currentType } = action.payload;
        const res = yield tCall(APIS.AnswerApi.answerAnswerIdAgreeUsingPost, {
          answerId,
          type: agreeDisagreeNextMap[clickedType][currentType].agreeStatus
        });
        if (res.code === 0 && res.result && Object.keys(res.result).length >= 2) {
          const { agreeCount = 0, disagreeCount = 0 } = res.result;
          yield tPut(model.actions.updateHomeAnswerAgreeDisagree, {
            index,
            agreeStatus: agreeDisagreeNextMap[clickedType][currentType].agreeStatus,
            agreeCount,
            disagreeCount
          });
          message.success(agreeDisagreeNextMap[clickedType][currentType].tip);
        } else {
          message.error(`${res.message || NETWORK_ERROR_TIP}`);
        }
      },
      {
        type: 'takeLatest'
      }
    ],
    /** 文章置顶 */
    *stickyGroupArticle(
      { tPut, tCall },
      action: Tction<{
        params: ParamsgroupsStickArticleOrQuestionIdUsingPut;
        pageNum: number;
        pageSize: number;
      }>
    ): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.GroupApi.groupsStickArticleOrQuestionIdUsingPut> = yield tCall(
        APIS.GroupApi.groupsStickArticleOrQuestionIdUsingPut,
        action.payload.params
      );
      const { stickType, type, groupId } = action.payload.params;
      const { pageSize, pageNum } = action.payload;
      if (res.code === 0) {
        if (type === 1) {
          yield tPut(model.actions.getNewArticleList, {
            params: { groupId, pageSize, pageNum, type },
            needLoading: false
          });
        } else if (type === 2) {
          yield tPut(model.actions.getAskList, {
            params: { groupId, pageSize, pageNum, type },
            needLoading: false
          });
        }
        message.success(stickType === 1 ? '已成功置顶' : '已取消置顶');
      } else {
        message.success(stickType === 1 ? '置顶失败' : '取消置顶失败');
      }
    },
    /**
     * @description 投票关注切换
     */
    *toggleVoteFollow(
      { tPut, tCall },
      action: Tction<{
        params: ParamsvoteFollowVoteQuestionIdUsingPost;
      }>
    ): Iterator<{}, any, any> {
      const { params } = action.payload;
      const res: Utils.GetROA<typeof APIS.VoteApi.voteFollowVoteQuestionIdUsingPost> = yield tCall(
        APIS.VoteApi.voteFollowVoteQuestionIdUsingPost,
        params
      );
      if (res.code === 0) {
        yield tPut(model.actions.updateVoteFollow, {
          voteId: params.voteQuestionId,
          type: params.type
        });
        message.success(params.type ? '已关注' : '已取消关注');
      } else {
        message.error(res.message);
      }
    },
    /** 全部同意加入圈子 */
    *agreeAllJoinGroup(
      { tPut, tCall },
      action: Tction<{
        groupId: number;
      }>
    ): Iterator<{}, any, any> {
      const { groupId } = action.payload;
      const res: Utils.GetROA<typeof APIS.GroupApi.groupsGroupIdAuditedAllOperaUsingPut> = yield tCall(
        APIS.GroupApi.groupsGroupIdAuditedAllOperaUsingPut,
        { groupId }
      );
      if (res.code === 0) {
        yield tPut(model.actions.setGroupUsersRequestList, {
          groupUsersRequireModel: {}
        });
        message.success('已全部同意加入圈子');
      } else {
        message.error(res.message);
      }
    },
    /**
     * @description 申请加入圈子免审批开关-打开/关闭
     */
    *getAppProval(
      { tPut, tCall },
      action: Tction<{
        groupId: number;
        status: number;
      }>
    ): Iterator<{}, any, any> {
      const { groupId, status } = action.payload;
      const res: Utils.GetROA<typeof APIS.GroupApi.groupsGroupIdApprovalUsingPut> = yield tCall(
        APIS.GroupApi.groupsGroupIdApprovalUsingPut,
        { groupId, status }
      );
      if (res.code === 0) {
        yield tPut(model.actions.updateGroupInfoChecked, { checked: status === 1 });
        message.success(`已${status ? '关闭' : '打开'}免申请加入圈子开关`);
      } else {
        message.error(res.message);
      }
    },
    /**
     * @description 删除问答
     */
    *deleteQuestion(
      { tPut, tCall },
      action: Tction<{
        groupId: number;
        status: number;
      }>
    ): Iterator<{}, any, any> {
      const { groupId, status } = action.payload;
      const res: Utils.GetROA<typeof APIS.GroupApi.groupsGroupIdApprovalUsingPut> = yield tCall(
        APIS.GroupApi.groupsGroupIdApprovalUsingPut,
        { groupId, status }
      );
      if (res.code === 0) {
        yield tPut(model.actions.updateGroupInfoChecked, { checked: status === 1 });
        message.success(`已${status ? '关闭' : '打开'}免申请加入圈子开关`);
      } else {
        message.error(res.message);
      }
    }
  }
});

export default model;
